import classNames from 'classnames';
import React, { useImperativeHandle, useRef, useState } from 'react';
import { Icon, IconName, Toast } from 'react-frontier';

interface UploadBoxProps{
	className?: string,
	type?: 'normal' | 'green' | 'red',
	text?: string,
	single?: boolean
	icon?: IconName,
	maxFileSize?: number,
	onFile: (file: File)=>void,
}

export interface UploadBoxRef{
	clear: ()=>void,
}

var UploadBox = React.forwardRef((props: UploadBoxProps, ref: React.Ref<UploadBoxRef>)=>{
	var idRef = useRef<HTMLInputElement>(null);
	var [isDragging, setIsDragging] = useState(false);

	useImperativeHandle(ref, ()=>({
		clear: ()=>{
			idRef.current.value = null;
			props.onFile(null);
		}
	}), [props.onFile])

	var processFiles = (files: FileList)=>{
		if(!files?.length) return;
		if(files.length>1 && props.single!==false) return Toast.error("Favor de solo seleccionar 1 archivo");
		var file = files[0];
		if(props.maxFileSize && file.size>props.maxFileSize) return Toast.error('El archivo no puede pesar mas de 8MB');
		props.onFile(file);
	}

	var handleDrag = (e: React.DragEvent<HTMLDivElement>, isDrag: boolean)=>{
		e.preventDefault();
		e.stopPropagation();
		setIsDragging(isDrag);
	}
	
	return <div 
		className={classNames("ar uploadbox", props.type, props.className, { 'dragging': isDragging })} 
		onClick={()=>idRef.current?.click()}
		onDragEnter={(e)=>handleDrag(e, true)}
		onDragOver={(e)=>e.preventDefault()}
		onDragLeave={(e)=>handleDrag(e, false)}
		onDrop={(e)=>{handleDrag(e, false); processFiles(e.dataTransfer.files);}}
	>
		<input type="file" ref={idRef} accept="image/*,application/pdf,video/*" onChange={(e)=>processFiles(e.target.files)} />
		<div className="contents">
			<Icon name={props.icon ?? 'file'} />
			<div className="text">{props.text ?? 'Da click o arrastra el archivo aquí'}</div>
		</div>
	</div>
})

export default UploadBox;